import Promise from 'bluebird'
import populateDefaultProjectValues from '../lib/preparations/populate-default-project-values.js'

export default function (input) {
  return new Promise((resolve) => {
    resolve( populateDefaultProjectValues(input) );
  });
};

